import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { CustomRouteService } from 'src/app/pages/custom-route/services/custom-route.service';
import { PlannerDayStateService } from '../../services';
import { DatePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-start-point',
  standalone: true,
  imports: [
    DatePipe,
    TranslateModule
  ],
  templateUrl: './start-point.component.html',
  styleUrls: ['./start-point.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class StartPointComponent  {
  private _customRouteService = inject(CustomRouteService);
  private _plannerDayStateService = inject(PlannerDayStateService);

  private readonly _customRouteData = computed(() => this._customRouteService.customRouteData());
  get dailyCustomRouteData() {
    return this._customRouteData().dailyRoutes[this._dayToShowIndex()];
  }
  
  private readonly _dayToShowIndex = computed(() => this._plannerDayStateService.dayToShowIndex());
  get dayToShowIndex() {
    return this._dayToShowIndex();
  }
  
  getstartDateForStartPoint(): Date | null {
    const firstPointOfCurrentDay = this.dailyCustomRouteData.points[0];
    if (!firstPointOfCurrentDay) return null;
    const startDateFirstPointCurrentDay = firstPointOfCurrentDay.startDate;
    
    const totalTransportDuration = firstPointOfCurrentDay.transportList.reduce((total, transport) => total + (transport.duration || 0), 0);
    
    const startDate = new Date(startDateFirstPointCurrentDay.getTime() - totalTransportDuration * 60000);
    
    return startDate;
  }
}
